
import { useState } from "react";
import Navbar from "../components/Navbar";

export default function MediaGallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  /* Gallery Data (with description) */

  const images = [
    {
      src: "/gallery/image1.jpeg",
      title: "कार्यक्रम उद्घाटन",
      desc: "बेटी जन्मोत्सव का शुभारंभ"
    },
    {
      src: "/gallery/image2.jpeg",
      title: "सम्मान समारोह",
      desc: "बालिकाओं को सम्मानित किया गया"
    },
    {
      src: "/gallery/image3.jpeg",
      title: "जन भागीदारी",
      desc: "स्थानीय लोगों की उपस्थिति"
    },
    {
      src: "/gallery/image4.jpeg",
      title: "जागरूकता अभियान",
      desc: "बेटी बचाओ संदेश"
    },
    {
      src: "/gallery/image5.jpeg",
      title: "स्कूल कार्यक्रम",
      desc: "विद्यालय में आयोजन"
    },
    {
      src: "/gallery/image6.jpeg",
      title: "सांस्कृतिक कार्यक्रम",
      desc: "बच्चों की प्रस्तुति"
    },
    {
      src: "/gallery/image7.jpeg",
      title: "महिला सशक्तिकरण",
      desc: "महिलाओं की भागीदारी"
    },
    {
      src: "/gallery/image8.jpeg",
      title: "स्वास्थ्य जांच",
      desc: "नि:शुल्क स्वास्थ्य शिविर"
    },
    {
      src: "/gallery/image9.jpeg",
      title: "पुरस्कार वितरण",
      desc: "विजेताओं को सम्मान"
    },
    {
      src: "/gallery/image10.jpeg",
      title: "सामूहिक कार्यक्रम",
      desc: "जनसमूह की भागीदारी"
    },
    {
      src: "/gallery/image11.jpeg",
      title: "विशेष अतिथि",
      desc: "अतिथियों का स्वागत"
    },
    {
      src: "/gallery/image12.jpeg",
      title: "समापन समारोह",
      desc: "कार्यक्रम का समापन"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-white">

      <Navbar />

      <div className="max-w-7xl mx-auto p-8">

        {/* Title */}

        <h1 className="text-4xl font-bold text-indigo-700 text-center mb-3">
          मीडिया गैलरी
        </h1>

        <p className="text-center text-gray-600 mb-10">
          बेटी जन्मोत्सव कार्यक्रम की सुंदर झलकियाँ
        </p>

        {/* Gallery Grid */}

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">

          {images.map((img, index) => (

            <div
              key={index}
              className="relative group rounded-xl overflow-hidden shadow-md hover:shadow-xl transition duration-300 cursor-pointer"
              onClick={() => setSelectedImage(img)}
            >

              <img
                src={img.src}
                alt={img.title}
                className="w-full h-52 object-cover group-hover:scale-110 transition duration-300"
              />

              {/* Overlay */}

              <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition flex flex-col justify-end p-4">

                <h3 className="text-white font-semibold text-lg">
                  {img.title}
                </h3>

                <p className="text-gray-200 text-sm">
                  {img.desc}
                </p>

              </div>

            </div>

          ))}

        </div>

      </div>

      {/* MODAL VIEW */}

      {selectedImage && (

        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">

          <div className="relative max-w-4xl w-full p-4">

            {/* Close Button */}

            <button
              className="absolute top-2 right-2 bg-white text-black px-3 py-1 rounded-full shadow"
              onClick={() => setSelectedImage(null)}
            >
              ✕
            </button>

            <img
              src={selectedImage.src}
              alt={selectedImage.title}
              className="w-full max-h-[80vh] object-contain rounded-lg shadow-lg"
            />

            <div className="bg-white p-4 rounded-b-lg">

              <h2 className="text-xl font-bold text-indigo-700">
                {selectedImage.title}
              </h2>

              <p className="text-gray-600">
                {selectedImage.desc}
              </p>

            </div>

          </div>

        </div>

      )}

    </div>
  );
}

